import React from 'react';
import WebhooksAccessLayout from '../../../components/WebhooksAccessLayout';
import { READ_WEBHOOK_CONFIG } from '../../../constants/webhookPermissions';

export default function WebhooksConfigAccessLayout() {
  return <WebhooksAccessLayout title="Webhooks" permission={READ_WEBHOOK_CONFIG} />;
}
